import { render, staticRenderFns } from "./OrderDetailQuantity.vue?vue&type=template&id=17746917&scoped=true"
import script from "./OrderDetailQuantity.vue?vue&type=script&lang=js"
export * from "./OrderDetailQuantity.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailQuantity.vue?vue&type=style&index=0&id=17746917&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17746917",
  null
  
)

export default component.exports